import { alpha } from '@material-ui/core';

// ----------------------------------------------------------------------

export default function Input(theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '& svg': { color: theme.palette.text.disabled }
          }
        },
        input: {
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled
          }
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56]
          }
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[100],
          '&:hover': {
            backgroundColor: theme.palette.grey[200]
          },
          '&.Mui-focused': {
            backgroundColor: theme.palette.grey[100]
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground
          }
        },
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[300]
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        // UI kit inputs carry an always-on bold ink-brown border + flat offset
        // shadow, switching to amber (not the conventional MUI primary-focus
        // ring alone) on focus — matches the kit's `.input` / `.input.focus`.
        root: {
          boxShadow: isLight ? `3px 4px 0 0 ${alpha(theme.palette.grey[800], 0.5)}` : 'none',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: isLight ? theme.palette.grey[800] : theme.palette.grey[300],
            borderWidth: 2.5
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: isLight ? theme.palette.grey[800] : theme.palette.grey[400]
          },
          '&.Mui-focused': {
            boxShadow: isLight ? `3px 4px 0 0 ${alpha(theme.palette.primary.dark, 0.55)}` : 'none'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
            borderWidth: 2.5
          },
          '&.Mui-disabled': {
            boxShadow: 'none',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.disabledBackground
            }
          }
        }
      }
    }
  };
}
